import seal from "../../assets/Background.png";
import CTA from "../../components/cta/cta";


const Footer = () => {

    return (
        <div className="relative overflow-hidden  bg-[linear-gradient(to_bottom,#e4e4f1,#ffffff)] text-center pb-10 flex flex-col items-center gap-10 border-t-[1px] border-gray-300">
            <img src={seal} alt="WPFFA Seal" className="w-[50px] h-[50px] md:w-[100px] md:h-[100px] mt-10 drop-shadow-[0_10px_15px_rgba(0,0,0,0.4)] border-1 border-red-500 mx-auto" />
            <CTA />
            <p>Waco Professional Firefighter Association © {new Date().getFullYear()}</p>
        </div>
    );
};

export default Footer;
